import styled, { css } from 'styled-components';

import { pxToRem, StatusColor } from 'utils/scss';

export const HistoryListContainer = styled.div`
  min-width: ${pxToRem('544px')};
  max-width: ${pxToRem('620px')};
  min-height: ${pxToRem('750px')};
  background-color: ${props => props.theme.colors.white};
  border: none;
  z-index: 95;
  padding: ${pxToRem('24px')} ${pxToRem('40px')};

  border-radius: ${pxToRem('24px')};
  box-shadow: ${pxToRem('11px')} ${pxToRem('11px')} ${pxToRem('22px')}
    ${pxToRem('-5px')} rgba(7, 11, 21, 0.08);

  > span:nth-child(2) {
  //  padding: ${pxToRem('16px')} 0;
  }
`;
export const SideButtonContainer = styled.div`
  position: relative;
`;
export const HistorySideButton = styled.div`
  height: ${pxToRem('40px')};
  width: ${pxToRem('60px')};
  border-radius: ${pxToRem('25px')} 0 0 ${pxToRem('25px')};
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  cursor: pointer;
  position: absolute;
  left: ${pxToRem('-25px')};
  top: ${pxToRem('-24px')};
  transform: translate(-90%, 0%);
  z-index: 2;
  > span {
    margin-left: 8px;
  }
`;
export const ListTitle = styled.div`
  text-align: center;
  margin-bottom: ${pxToRem('40px')};
`;
export const HistoryRowsContainer = styled.div`
  height: 90%;
  overflow-y: auto;
`;
export const HistoryRow = styled.div`
  padding: ${pxToRem('16px')} 0;
  &:not(:last-child) {
    border-bottom: ${pxToRem('1px')} solid
      ${props => props.theme.colors.black.seven};
  }
`;
export const NoUpdate = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${pxToRem('158px')};
  align-items: center;
  > span {
    margin-bottom: ${pxToRem('40px')};
  }
`;
export const HistoryDate = styled.div`
  color: ${props => props.theme.colors.grayText};
`;
export const HistoryNote = styled.div`
  margin: ${pxToRem('8px')} 0 0 0;

  ${props =>
    props.flex &&
    css`
      display: -webkit-box;
    `}
  > span {
    margin-right: ${pxToRem('2px')};
  }
`;
export const HistoryStatus = styled.div`
  ${props => props.value && StatusColor(props.value)};
  border-radius: ${pxToRem('20px')};
  padding: ${pxToRem('6px')} ${pxToRem('24px')};
  height: ${pxToRem('28px')};
  font-size: ${pxToRem('12px')};
  font-weight: bold;
  text-transform: uppercase;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: ${pxToRem('2px')};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'OpenSans';
  margin: 0 ${pxToRem('4px')};
`;
